import {arrayInArray, inArray, is_array} from "../../../helpers/arrays";
import {isEmpty} from "../../../helpers/helpers";

const districtsCoveredByInvestment = {
    golbahar: [199, 262],
    qasemAbad: [
        618, // قاسم آباد
    ],
    elahieh: [
        60, // الهیه
        62, // بلوار امیریه
        67, // بلوار سجادیه
        2072, // جاهدشهر
    ],
    azadShahr: [
        258, // بلوار وکیل آباد
        30, // بلوار سیدرضی
        28, // بلوار دانشجو
        1439, // آزادشهر
        24, // بلوار فارغ التحصیلان
        235, // ستاری
        27, // خیابان صدف
        33, // بلوار فرهنگ
    ],
    tollab: [
        1755, // طلاب
        163, // طبرسی (بلوار اول)
        164, // طبرسی (بلوار دوم)
        165, // بلوار رسالت
        161, // بلوار گاز
        1934, // راه آهن
        45671, // محله تلگرد
        247, // وحید
        1817, // ابوذر ( منطقه 3 )
        6829, // چهارراه مقدم
        183, // پنج تن
        182, // گلشهر ( آوینی )
        2073, // مهرآباد
    ],
    holyShrine: [
        146, // ۱۷ شهریور
        241, // دانش
        3827, // عنصری
        2759, // حرم مطهر
        137, // امام رضا
        1963, // عامل
        1440, // عدل خمینی
        1945, // فلکه برق (میدان بسیج)
        4228, // فلکه ضد (۱۵ خرداد)
        111, // خیابان شیرازی
    ],
};

const million = 1000000;

const minPricesInvestmentByDistricts = {
    golbahar: 50 * million,
    qasemAbad: 350 * million,
    elahieh: 600 * million,
    azadShahr: 700 * million,
    tollab: 400 * million,
    holyShrine: 350 * million
};

const minPricesInvestmentByCity = {
    207: 350 * million,
};


export const getExpertNumberForRequestForm = (city_id, district_id) => {

    let tel = '';
    const districtId = Number(district_id);
    const cityId = Number(city_id);

    if (inArray(districtId, districtsCoveredByInvestment.golbahar) || inArray(cityId, districtsCoveredByInvestment.golbahar)) {
        tel = '' // 09190612274 - گلبهار
    } else if (inArray(districtId, districtsCoveredByInvestment.azadShahr)) {
        tel = ''; // منطقه آزادشهر - 09190612096
    } else if (inArray(districtId, districtsCoveredByInvestment.qasemAbad) || inArray(districtId, districtsCoveredByInvestment.elahieh)) {
        tel = ''; // منطقه قاسم‌آباد و الهیه - 09190612097
    } else if (inArray(districtId, districtsCoveredByInvestment.tollab)) {
        tel = ''; // منطقه طلاب - 09150303080
    } else if (inArray(districtId, districtsCoveredByInvestment.holyShrine)) {
        tel = '' //09120054368 -  منطقه نزدیک حرم
    }

    return tel;
};

/**
 * @param city_id {Number}
 * @param district_id {Array}
 *
 * @return Number
 * */
export function getInvestmentMinPriceByDistrict(city_id, district_id) {
    let min_price = 400 * million;
    let isDefault = true;

    for (let district in districtsCoveredByInvestment) {
        const districtIds = !isEmpty(districtsCoveredByInvestment[district]) ? districtsCoveredByInvestment[district] : [];

        if (isEmpty(district_id) || !is_array(district_id)) {
            district_id = [district_id];
        }

        if ((inArray(city_id, districtIds) || arrayInArray(district_id, districtIds)) && !isEmpty(minPricesInvestmentByDistricts[district])) {
            min_price = minPricesInvestmentByDistricts[district];
            isDefault = false;
        }
    }

    if (isDefault && inArray(city_id, Object.keys(minPricesInvestmentByCity))) {
        min_price = minPricesInvestmentByCity[city_id];
    }

    return min_price;
}